import { API } from './services/typings';

export default function access(initialState: { user?: API.User | undefined }) {
  const { user } = initialState || {};
  return {
    canAdmin: user && user.is_admin == true,
  };
}
